import clsx from "clsx";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { IApplicationState } from "../../state/ducks";
import { MenuReducerState, menuAction } from "../../state/ducks/menu";

export interface MenuItemProps extends React.LiHTMLAttributes<HTMLLIElement> {
  datakey: string;
  children?: React.ReactNode;
}

const Component: React.FC<MenuItemProps> = (props) => {
  // const setMenuState = useSetRecoilState(menuState);
  const state = useSelector<IApplicationState, MenuReducerState>(
    (state) => state.menu
  );
  const dispatch = useDispatch();

  const {
    datakey: dataKey = "",
    onClick,
    className,
    children,
    ...other
  } = props;

  const classNames = clsx(
    `menu-item`,
    {
      selected: state.selectedDatakey === dataKey,
    },
    className
  );

  const handleOnClick = (
    event: React.MouseEvent<HTMLLIElement, MouseEvent>
  ) => {
    dispatch(menuAction({selectedDatakey: dataKey}));
    if (onClick) onClick(event);
  };

  return (
    <li className={classNames} onClick={handleOnClick} {...other}>
      {children}
    </li>
  );
};

export const MenuItem = React.memo(Component);
